<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: luoxi
 * @LastEditTime: 
 -->
<template>
  <div class="file-title" @click="clicks">
    <!-- <i class="iconfont fileanquanwangpan"></i> -->
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    name() {
      return this.$store.state.system.name;
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    clicks(){
      window.location.href='http://www.interkultur.com.cn/'
    }
  },
};
</script>

<style scoped="" lang="scss">
.file-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  margin: 12px 23px;
  width: 194px;
  cursor: pointer;
  background: url("../../assets/images/ik-logo.png") no-repeat;
  background-size: auto;
  i {
    font-size: 30px;
    margin-right: 10px;
    color: #66788c;
    padding-top: 3px;
  }
  h1 {
    font-size: 1.5rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(102, 120, 140, 1);
    letter-spacing: 0.1rem;
  }
}
</style>
